import * as React from "react"

function IconEnergy(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={41} height={16} viewBox="0 0 41 16" {...props}>
      <title>{"Feature/energy"}</title>
      <g stroke="#FFF" fill="none" fillRule="evenodd">
        <path d="M1 1h34.517v14H1zM40 4.5h-4.483v7H40zM8.171 4.5v7M14.897 4.5v7M21.621 4.5v7M28.345 4.5v7" />
      </g>
    </svg>
  )
}

export default IconEnergy
